/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]   .circle-color[_ngcontent-%COMP%]{display:flex;justify-content:center;align-items:center;border-radius:50%;font-size:1.6666666667em;font-weight:400;color:#fff}[_nghost-%COMP%]   .circle-color.square[_ngcontent-%COMP%]{border-radius:6px}[_nghost-%COMP%]   .profile-img-block[_ngcontent-%COMP%]{position:relative}[_nghost-%COMP%]   .profile-img-block-svg[_ngcontent-%COMP%]{position:absolute;bottom:0;right:0;font-size:15px}"];
export { styles as styles };
